import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { toggleCasinoSounds } from 'containers/App/actions';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

class MobileHamburgerMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openSubMenus: []
    };

    this.toggleSounds = this.toggleSounds.bind(this);
  }

  toggleSubMenu(id) {
    const { openSubMenus } = this.state;
    const newOpenSubMenus = _.includes(openSubMenus, id)
      ? _.without(openSubMenus, id)
      : [...openSubMenus, id];

    this.setState({
      openSubMenus: newOpenSubMenus
    });
  }

  toggleSounds() {
    const { toggleCasinoSounds } = this.props;

    toggleCasinoSounds();
  }

  render() {
    const { openSubMenus } = this.state;
    const { items, close, casinoSoundsOn } = this.props;

    return (
      <div className="mobile-menu-container">
        <div className="mobile-menu-overlay" onClick={close} />
        <div className="mobile-menu">
          <ul>
            {items &&
              items.map((item, i) => {
                const id = `${item.name}_${i}`;
                const hasChildren = item.children && item.children.length > 0;
                const classes = [
                  hasChildren ? 'has-children' : '',
                  _.includes(openSubMenus, id) ? 'active' : ''
                ].join(' ');

                return (
                  <li
                    key={id}
                    className={classes}
                    onClick={
                      hasChildren ? this.toggleSubMenu.bind(this, id) : null
                    }
                  >
                    <a href={item.url || '#'}>{item.name}</a>
                    {hasChildren && (
                      <ul>
                        {item.children.map((childItem, i) => (
                          <li key={`${childItem.name}_${i}`}>
                            <a href={childItem.url}>{childItem.name}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            <li key={'toggleSounds'}>
              <a href="#" onClick={this.toggleSounds}>
                Casino Sounds {casinoSoundsOn ? 'Off' : 'On'}
              </a>
            </li>
            <li key={'logout'}>
              <a href="/logout">Sign Out</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

MobileHamburgerMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      children: PropTypes.arrayOf({
        name: PropTypes.string,
        url: PropTypes.string
      })
    })
  ),
  casinoSoundsOn: PropTypes.bool,
  toggleCasinoSounds: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  toggleCasinoSounds: () => dispatch(toggleCasinoSounds())
});

const mapStateToProps = createStructuredSelector({
  casinoSoundsOn: makeSelectCasinoSoundsOn()
});

export default connect(mapStateToProps, mapDispatchToProps)(
  MobileHamburgerMenu
);



// WEBPACK FOOTER //
// ./src/components/MobileHamburgerMenu/index.js